import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "../Log/Login";
import RegistrationPage from "../User/Reg/Reg";
import User from "../User/UserCommon/UserCommon";
import HomePage from "../User/Home/Home";
import AdminCommon from "../Admin/AdminCommon/AdminCommon";
import ForgotPassword from "../Log/Forgotpass";
import ResetPassword from "../Log/Resetpass";
import VerifyOTP from "../Log/VerifyOtp";

// User Routes
import Card from "../User/Card/AddCard/addcard";
import CardGroup from "../User/CardGroup/AddCardgrps/cardgrps";
import GameCategory from "../User/GameCategory/AddCategory/addcategory";
import GameMaster from "../User/GameMaster/AddMaster/addmaster";
import GameMasterTable from "../User/GameMaster/mastertable"
import GameCardAllocation from "../User/GameCardAllocation/AddAllocation/addallocation";
import CardGroupTable from "../User/CardGroup/cardgroupTable"
import CardTable from "../User/Card/cardTable"
import GameCategoryTable  from "../User/GameCategory/categorytable"
import GameAllocationTable from "../User/GameCardAllocation/gameallocTable"
import CardScenario from "../User/PlayDB/AddPlay/addplay"
import PlayDbTable from "../User/PlayDB/playdbtable"
import UpdateCardGroup from "../User/CardGroup/UpdateCardgrp/updatecardgrp";
import ViewCardGroup from "../User/CardGroup/ViewCardgrp/viewcardgrp"
import ViewCard from "../User/Card/ViewCard/viewcard";
import UpdateCard from "../User/Card/UpdateCard/updatecard"
import UpdateCategory from "../User/GameCategory/UpdateCategory/updatecategory";
import ViewCategory from "../User/GameCategory/ViewCategory/viewcategory"
import ViewGameMaster from "../User/GameMaster/ViewMaster/viewmaster";
import UpdateGameMaster from "../User/GameMaster/UpdateMaster/updatemaster";
import UpdateAllocation from "../User/GameCardAllocation/UpdateAllocation/updatealloc";
import ViewAllocation from "../User/GameCardAllocation/ViewAllocation/viewalloc";
import ViewPlay from "../User/PlayDB/ViewPlay/viewplay";
import UpdatePlay from "../User/PlayDB/UpdatePlay/updateplay";
import AddNetwork from "../User/Network/AddNetwork/addnet";
import NetworkTable from "../User/Network/networktable";
import UpdateNetwork from "../User/Network/UpdateNetwork/updatenet";
import ViewNetwork from "../User/Network/ViewNetwork/viewnet";
import GameHistory from "../User/PlayDB/AddPlay/userhistory"
import EditProfile from '../User/UserCommon/editprofile';
import AIPolicy  from "../../src/User/Reg/Aipolicy"
import OnlinePlayers from "../User/PlayDB/AddPlay/onlineplay"
import MultiplayerGame from "../User/PlayDB/AddPlay/multiplayer";
import CubeGame from "../User/CubeGame/cubegame"
import ChakraGameTable from "../User/ChakraGame/ChakraGameTable"
import AddChakraGame from "../User/ChakraGame/addchakra"
import VajrachakraTable from "../User/ChakraGame/Vajrachakra/vajrachakratable";
import ChariotTable from "../User/ChakraGame/ChariotTable/chariottable";
import UpdateChakraGame from "../User/ChakraGame/updatechakra";
import ViewChakraData from "../User/ChakraGame/viewchakra";
import AddChariot from "../User/ChakraGame/ChariotTable/addchariot";
import UpdateChariot from "../User/ChakraGame/ChariotTable/updatechariot";
import ViewChariot from "../User/ChakraGame/ChariotTable/viewchariot";
import AllChakras from "../User/ChakraGame/chakraimg"
import ChakraForm from "../User/ChakraGame/chakramaster";
import MoralSciencePage from "../User/ChakraGame/ChariotTable/chariotgame"
import CubeMaster from "../User/CubeGame/cubemaster";
import Cube from "../User/CubeGame/cube";
import AddCube from "../User/CubeGame/AddCube/addcube";
import ViewCube from "../User/CubeGame/ViewCube/viewcube";
import UpdateCube from "../User/CubeGame/UpdateCube/updatecube"
import Cross from "../User/CrossGame/cross";
import CrossGame from "../User/CrossGame/crossgame";
import Tao from "../User/YingYangGame/yingyang";
import TaoGame from "../User/YingYangGame/yingyanggame";
import Zoro from "../User/ZoroastrianismGame/zoro";
import ZoroGame from "../User/ZoroastrianismGame/zorogame";
import Sikh from "../User/SikhGame/sikh";
import SikhGame from "../User/SikhGame/sikhgame";
import Torah from "../User/TorahGame/torah";
import TorahGame from "../User/TorahGame/torahgame";
import African from "../User/AfricanGame/african";
import AfricanGame from "../User/AfricanGame/africangame";
import Datta from "../User/DattaGame/datta";
import DattaGame from "../User/DattaGame/dattagame";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" />;
};

const MainCommon = () => {
  return (
    <div>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="login" element={<LoginForm />} />
          <Route path="register" element={<RegistrationPage />} />
          <Route path="reset-password/:token" element={<ResetPassword />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="verify-otp" element={<VerifyOTP />} />
          <Route path="/ai-policy" element={<AIPolicy  />} />


          {/* Protected user routes */}
          <Route path="/" element={<PrivateRoute><User /></PrivateRoute>}>
            <Route index element={<HomePage />} />
            <Route path="editprofile" element={<EditProfile />} />
            <Route path="Addcard" element={<Card />} />
            <Route path="cardtable" element={<CardTable />} />
            <Route path="viewcard/:cardid" element={<ViewCard />} />
            <Route path="updatecard/:cardid" element={<UpdateCard />} />

            <Route path="Addcardgroup" element={<CardGroup />} />
            <Route path="cardgrouptable" element={<CardGroupTable />} />
            <Route path="viewcardgrp/:cardgrpid" element={<ViewCardGroup />} />
            <Route path="updatecardgrp/:cardgrpid" element={<UpdateCardGroup />} />

            <Route path="addgamecategory" element={<GameCategory />} />
            <Route path="categorytable" element={<GameCategoryTable  />} />
            <Route path="viewcategory/:gamecategoryid" element={<ViewCategory />} />
            <Route path="updatecategory/:gamecategoryid" element={<UpdateCategory />} />

            <Route path="addgamemaster" element={<GameMaster />} />
            <Route path="gamemastertable" element={<GameMasterTable />} />
            <Route path="viewmaster/:gamemasterid" element={<ViewGameMaster />} />
            <Route path="updatemaster/:gamemasterid" element={<UpdateGameMaster />} />

            <Route path="addcardalloc" element={<GameCardAllocation />} />
            <Route path="cardalloctable" element={<GameAllocationTable />} />
            <Route path="viewalloc/:cardallocid" element={<ViewAllocation />} />
            <Route path="updatealloc/:cardallocid" element={<UpdateAllocation />} />

            <Route path="addplaydb" element={<CardScenario />} />
            <Route path="playdbtable" element={<PlayDbTable/>}/>
            <Route path="viewplay/:playid" element={<ViewPlay />} />
            <Route path="updateplay/:playid" element={<UpdatePlay />} />
            <Route path="onlineplay" element={<OnlinePlayers />} />
            <Route path="multiplayergame" element={<MultiplayerGame />} />

            <Route path="addnetwork" element={<AddNetwork />} />
            <Route path="networktable" element={<NetworkTable/>}/>
            <Route path="viewnetwork/:netid" element={<ViewNetwork />} />
            <Route path="updatenetwork/:netid" element={<UpdateNetwork />} />
 
           <Route path="history" element={<GameHistory />} />         

           <Route path="/chakragametable" element={<ChakraGameTable />} />
           <Route path="/addspoke" element={<AddChakraGame type="spoke" />} />
           <Route path="/addblade" element={<AddChakraGame type="blade" />} />
           <Route path="/updatespoke/:spokeid" element={<UpdateChakraGame type="spoke" />} />
           <Route path="/updateblade/:bladeid" element={<UpdateChakraGame type="blade" />} />
           <Route path="/viewspoke/:spokeid" element={<ViewChakraData type="spoke"/>} />
           <Route path="/viewblade/:bladeid" element={<ViewChakraData type="blade"/>} />

           <Route path="/vajrachakratable" element={<VajrachakraTable />} />  
           <Route path="/chariottable" element={<ChariotTable />} />  
           <Route path="/addglobal" element={<AddChariot/>} /> 
           <Route path="/addchariot" element={<AddChariot />} /> 
           <Route path="/updateglobal/:globalid" element={<UpdateChariot type="global" />} />
           <Route path="/updatechariot/:chariotid" element={<UpdateChariot type="chariot" />} />
           <Route path="/viewglobal/:globalid" element={<ViewChariot type="global" />} />
           <Route path="/viewchariot/:chariotid" element={<ViewChariot type="chariot" />} />

           <Route path="/allchakra" element={<AllChakras/>} />
           <Route path="/chakramaster" element={<ChakraForm/>} /> 
           <Route path="/chariotgame" element={<MoralSciencePage/>} /> 

           <Route path="/cubegame" element={<CubeGame />} />
           <Route path="/cubemaster" element={<CubeMaster/>} />
           <Route path="/cube" element={<Cube/>} />
           <Route path="/addcube" element={<AddCube/>} /> 
           <Route path="viewcube/:cubeid" element={<ViewCube />} />
           <Route path="updatecube/:cubeid" element={<UpdateCube />} />

           <Route path="/cross" element={<Cross />} />
           <Route path="/crossgame" element={<CrossGame />} />
           <Route path="/yingyang" element={<Tao />} />
           <Route path="/yingyanggame" element={<TaoGame />} />
           <Route path="/zoro" element={<Zoro />} />
           <Route path="/zorogame" element={<ZoroGame />} />
           <Route path="/sikh" element={<Sikh />} />
           <Route path="/sikhgame" element={<SikhGame />} />
           <Route path="/torah" element={<Torah />} />
           <Route path="/torahgame" element={<TorahGame />} />
           <Route path="/african" element={<African />} />
           <Route path="/africangame" element={<AfricanGame />} />
           <Route path="/datta" element={<Datta />} />
           <Route path="/dattagame" element={<DattaGame />} />

            {/* You can define a catch-all route for unknown user routes */}
            <Route path="*" element={
              <div>
                <h1>404 - Page Not Found</h1>
                <p>The page you're looking for does not exist.</p>
              </div>
            } />
          </Route>

          {/* Protected admin routes */}
          <Route path="admin" element={<PrivateRoute><AdminCommon /></PrivateRoute>} />
        </Routes>
      </Router>
    </div>
  );
};

export default MainCommon;
